
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import StarRating from "vue-star-rating";

export default {
  name: "Rating",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker,
    VueTimepicker,
    StarRating
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      decimal_separator: ".",
precision: 0,
      currency: "",
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      period: "",
      storeList: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: "",
        to_date: "",
        from_date: ""
      },
      receipt: ""
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      this.$api
        .getAPI({
          _action: "/report/rating/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj,
          _hide_loader: true
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle("No Review & Rating Found");
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getReceiptDetail(receipt) {
      this.receipt = receipt;
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/report/export_rating/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'ratings.csv'})
    }
  },
  mounted() {

    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    this.getStoreList();
    this.getList(1);
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="card-body">
                <!-- <div class="pink-tape py-1">
                  <div class="row">
                    <div class="col-lg-9 col-5 align-self-center">
                      <a
                        href="javascript:void(0)"
                        class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                        @click="getExport()"
                      >
                        {{$lang.messages.export}}
                        <i class="mdi mdi-download align-text-top"></i>
                      </a>
                    </div>
                  </div>
                </div>-->

                <table class="table table-striped table-style-1 table-responsive">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'sale_number')"
                      >{{$lang.messages.receipt_no}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'review_date')"
                      >{{$lang.messages.review_date}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'customer_name')"
                      >{{$lang.messages.customer_name}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'store_name')"
                      >{{$lang.messages.store_name}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'average_rating')"
                      >{{$lang.messages.average_rating}}</th>
                      <th scope="col">{{$lang.messages.review}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :key="item.id"
                      data-toggle="modal"
                      data-target="#SalesDetail"
                      class="clickable-row"
                      v-for="(item,i) in list"
                      @click="getReceiptDetail(item)"
                    >
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{item.sale_number}}</td>
                      <td>{{item.review_date | moment("MMM DD, YYYY")}}</td>
                      <td>{{item.customer_name}}</td>
                      <td>{{item.store_name}}</td>
                      <td>
                        <star-rating
                          :inline="true"
                          :star-size="20"
                          :read-only="true"
                          :show-rating="false"
                          :rating="item.average_rating"
                        ></star-rating>
                      </td>
                      <td v-if="item.review.length > 10">{{item.review.substring(0, 10) + "..."}}</td>
                      <td v-else>{{item.review}}</td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right side modal Sales -->
    <div
      class="modal right fade"
      id="SalesDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header d-block text-center">
            <h3
              class="modal-title f-semi-bold font-20"
              id="myModalLabel2"
            >{{$lang.messages.rating_review}}</h3>
          </div>
          <div class="modal-body" style="padding-bottom: 0; border-bottom:1px solid #ddd">
            <div class="card">
              <div class="card-body px-0 pt-0">
                <p class="font-16">
                  <span class="f-semi-bold mr-2">{{$lang.messages.customer_name}}:</span>
                  {{receipt.customer_name}}
                </p>
                <p class="font-16">
                  <span class="f-semi-bold mr-2">{{$lang.messages.store_name}}:</span>
                  {{receipt.store_name}}
                </p>
                <p class="font-16">
                  <span class="f-semi-bold mr-2">{{$lang.messages.review_date}}:</span>
                  {{receipt.review_date | moment("MMM DD, YYYY")}}
                </p>
                <h4 class="text-dark font-20">{{$lang.messages.rating}}</h4>
                <table class="table table-style-1 table-responsive table-borderless mt-0 bg-light">
                  <tbody>
                    <tr v-for="item in receipt.list" :key="item.id">
                      <td class="px-3 py-1" style="vertical-align:middle">{{item.parameter}}</td>
                      <td>
                        <star-rating
                          :inline="true"
                          :star-size="20"
                          :read-only="true"
                          :show-rating="false"
                          :rating="item.rating"
                        ></star-rating>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h4 class="text-dark font-20">{{$lang.messages.review}}</h4>
                <p class="bg-light p-2">{{receipt.review}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-content -->
  </div>
</template>
